import { Survey } from '../model/SurveyModel';

const content: Survey = [
  {
    id: '0bff27c7-bebf-47a7-a1cb-22fbbe27fbfb',
    name: 'step-one',
    question: 'Which system notifications would you like to receive & via which channel(s)?',
    type: 'multichoice',
    categories: [
      { title: 'Booking & personalized offer requests', name: 'booking_po_requests' },
      { title: 'Personalized offer sent', name: 'personalized_offer_sent' },
      { title: 'Booking confirmations', name: 'confirmations' },
      { title: 'Confirmed booking reminders', caption: 'Before the trip date/time', name: 'confirmed_booking_reminder' },
      { title: 'Booking reschedule request', name: 'reschedule_request' },
      { title: 'Confirmation of reschedule booking', name: 'confirmated_reschedule' },
      { title: 'Booking cancellation by guest', name: 'guest_cancellation' },
      { title: 'Confirmation of booking canceled by you', name: 'host_cancellation_confirmed' },
      { title: 'Expired requests', caption: 'For bookings / personalized offer requests', name: 'expired_request' },
      { title: 'New chat messages', name: 'new_message' },
      { title: 'Payments', caption: 'Payout sent, Updated invoice / credit note', name: 'payments' },
      { title: 'New review received', name: 'new_review' },
    ],
    options: [
      { type: 'option', value: 'Email' },
      { type: 'option', value: 'WL app' },
      { type: 'option', value: 'SMS' },
      { type: 'opentext', value: 'Other' },
      { type: 'option', value: 'None' },
    ]
  },
  {
    id: '356ca541-61dc-40d1-a5df-ba42a8234a3a',
    name: 'step-two',
    question: 'Which updates from the Withlocals team would you like to receive & via which channel(s)?',
    type: 'multichoice',
    categories: [
      { title: 'New Originals experiences in my city / area of expertise', name: 'new_originals' },
      { title: 'Changes to my Withlocals Originals itineraries', name: 'itinerary_changes' },
      { title: 'New courses / learning center content', name: 'new_courses' },
      { title: 'Withlocals partnerships updates', name: 'partnership_updates' },
      { title: 'New Withlocals platform features', name: 'platform_updates'},
      { title: 'Withlocals marketing projects for hosts', name: 'marketing' },
      { title: 'Global host community news', name: 'global_host_news' },
      { title: 'Local host community news', name: 'local_host_news'},
      { title: 'Sustainability updates', name: 'sustainability' },
    ],
    options: [
      { type: 'option', value: 'Email' },
      { type: 'option', value: 'WL app' },
      { type: 'option', value: 'SMS' },
      { type: 'opentext', value: 'Other' },
      { type: 'option', value: 'None' },
    ]
  },
  {
    id: '6e497272-a08f-47d9-a8e1-b2e49d930ca3',
    name: 'step-three',
    question: 'How do you feel about the communication you currently receive from Withlocals?',
    type: 'singlechoice',
    options: [
      '🙁 Unhappy',
      '😐 So-so',
      '🙂 Satisfied',
      '🤩 Very happy',
    ]
  }
];

export default content;
